import { useEffect, useRef } from "react";
import QRCodeStyling from "qr-code-styling";

const StyledQRCode = ({ value, width, height, margin, style }) => {
    const containerRef = useRef(null);
    const qrCode = useRef(
        new QRCodeStyling({
            width,
            height,
            type: "svg",
            margin,
            qrOptions: { errorCorrectionLevel: "H" },
            dotsOptions: { type: "rounded", color: "#000000" },
            cornersSquareOptions: { type: "extra-rounded" },
            backgroundOptions: { color: "#ffffff" },
        })
    );

    useEffect(() => {
        const container = containerRef.current;
        qrCode.current.append(container);
        return () => { container.innerHTML = ""; };
    }, []);

    useEffect(() => {
        qrCode.current.update({ data: value });
    }, [value]);

    useEffect(() => {
        qrCode.current.update({ width, height, margin });
    }, [width, height, margin]);

    return <div ref={containerRef} style={{ overflow: "hidden", width, height, ...style }} />;
};

export default StyledQRCode;
